import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ApiService } from '../Services/apiServices';
import { showToast } from '../Utlis/toastUtlis';

const Footer = () => {

    const [settings, setSettings] = useState("");
    const [company, setCompany] = useState([]);
    const [loading, setLoading] = useState(false);


    const [newsletter, setNewsLetter] = useState({
        newsletter_email: '',
    });

    const handlenewsletterChange = (e) => {
        setNewsLetter({
            ...newsletter,
            [e.target.name]: e.target.value,
        });
    };

    const handleNewsLetter = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!newsletter.newsletter_email) {
            showToast("error", "Please Enter Email");
            setLoading(false);
            return false;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(newsletter.newsletter_email)) {
            showToast("error", "Please enter a valid email address");
            setLoading(false);
            return false;
        }

        try {
            const newsletterData = await ApiService.Commanpostrequest("news_letter", newsletter);

            if (newsletterData.success) {
                showToast("success", "Thank you for subscribing to our newsletter!");
                setNewsLetter({ newsletter_email: '' });
            } else {
                showToast("error", newsletterData.message || "Subscription failed. Please try again.");
            }
        } catch (error) {
            console.error("Subscription error:", error);

            if (error.response && error.response.data.errors) {
                const errors = error.response.data.errors;
                if (errors.newsletter_email) {
                    showToast("error", errors.newsletter_email[0]); 
                }
            } else {
                showToast("error", "An error occurred. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        const fetchsettings = async () => {
            try {
                const settingData = await ApiService.Commanfetchrequest('setting');
                setSettings(settingData);
                // console.log('setting data:', settingData);
            } catch (error) {
                console.log('error while fetching:', error);
            }
        }






        const fetchcompany = async () => {
            try {
                const companyData = await ApiService.Commanfetchrequest('company');
                setCompany(companyData);
                // console.log('company data:', companyData);
            } catch (error) {
                console.log('error while fetching:', error);
            }
        }


        fetchsettings();
        fetchcompany();
    }, []);


    return (
        <div>

            {/* Newsletter Start */}
            <div className="container newsletter mt-5 wow fadeIn" data-wow-delay="0.1s">
                <div className="row justify-content-center">
                    <div className="col-lg-10 border rounded p-1">
                        <div className="border rounded text-center p-1">
                            <div className="bg-white rounded text-center p-5">
                                <h4 className="mb-4">
                                    Subscribe Our <span className="text-primary text-uppercase">Newsletter</span>
                                </h4>
                                <div className="mx-auto" style={{ maxWidth: 400 }}>
                                    <div className="d-flex flex-column flex-md-row gap-2">
                                        <input
                                            className="form-control w-100 py-3 ps-4 pe-5"
                                            type="email"
                                            name='newsletter_email'
                                            placeholder="Enter your email"
                                            onChange={handlenewsletterChange}
                                            value={newsletter.newsletter_email}
                                        />
                                        <button
                                            type="submit"
                                            className="btn btn-primary px-4 py-3 w-100 w-md-auto"
                                            style={{ fontSize: "14px" }}
                                            disable={loading}
                                            onClick={handleNewsLetter}
                                        >
                                            {loading ? 'Loading...' : 'Submit'}

                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Newsletter Start */}
            {/* Footer Start */}
            <div className="container-fluid bg-dark text-light footer wow fadeIn" data-wow-delay="0.1s">
                <div className="container pb-5">
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-4">
                            <div className="bg-primary rounded p-4">
                                <a href="index.html"><h1 className="text-white  mb-3"><span style={{ color: "#FEA116" }}>{settings?.site_name}</span></h1></a>
                                <p className="text-white mb-0" dangerouslySetInnerHTML={{ __html: settings?.site_description }}>

                                </p>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-3">
                            <h6 className="section-title text-start text-primary text-uppercase mb-4">Contact</h6>
                            {settings ? (
                                <>
                                    <p className="mb-2">
                                        <i className="fa fa-map-marker-alt me-3" />
                                        <a style={{ textDecoration: "none", color: "#fff" }}
                                            href={`https://www.google.com/maps/search/?q=${encodeURIComponent(settings?.site_address || 'Jaipur Rajasthan')}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {settings?.site_address || 'Jaipur Rajasthan'}
                                        </a>
                                    </p>
                                    <p className="mb-2"><i className="fa fa-phone-alt me-3" /><a style={{ textDecoration: "none", color: "#fff" }} href='{"tel:" + settings?.site_phone}'>{settings?.site_phone || '+1 5589 55488 55'}</a></p>
                                    <p className="mb-2"><i className="fa fa-envelope me-3" /><a style={{ textDecoration: "none", color: "#fff" }} href='{"mailto:" + settings?.site_email}'>{settings?.site_email || 'info@example.com'}</a></p>
                                    <div className="d-flex pt-2">
                                        {settings?.twitter_url != null ? (
                                            <a className="btn btn-outline-light btn-social"
                                                href={settings?.twitter_url} target='new'>
                                                <i className="fab fa-twitter" />
                                            </a>
                                        ) : (
                                            ""
                                        )}

                                        {settings?.facebook_url != null ? (
                                            <a className="btn btn-outline-light btn-social"
                                                href={settings?.facebook_url} target='new'>
                                                <i className="fab fa-facebook-f" />
                                            </a>
                                        ) : (
                                            ""
                                        )}

                                        {settings?.instagram_url != null ? (
                                            <a className="btn btn-outline-light btn-social"
                                                href={settings?.instagram_url} target='new'>
                                                <i className="fab fa-instagram" />
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                </>
                            ) : (
                                ""
                            )}

                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="row gy-5 g-4">
                                <div className="col-md-6">
                                    <h6 className="section-title text-start text-primary text-uppercase mb-4">Company</h6>
                                    {company.map((value, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <Link to={value?.url} className="btn btn-link">{value?.title}</Link>
                                            </React.Fragment>
                                        )
                                    })}
                                </div>
                                <div className="col-md-6">
                                    <h6 className="section-title text-start text-primary text-uppercase mb-4">Services</h6>
                                    <a className="btn btn-link" href>Food &amp; Restaurant</a>
                                    <a className="btn btn-link" href>Spa &amp; Fitness</a>
                                    <a className="btn btn-link" href>Sports &amp; Gaming</a>
                                    <a className="btn btn-link" href>Event &amp; Party</a>
                                    <a className="btn btn-link" href>GYM &amp; Yoga</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="copyright">
                        <div className="row">
                            <div className="col-md-6 text-center mb-3 mb-md-0">
                                © <Link to="/" className="border-bottom" >WeJai</Link>, All Right Reserved |
                                Designed & Developed By <a target='_new' className="border-bottom" href="https://loopring.in">Loopring India Pvt. Ltd.</a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* Footer End */}
        </div>

    )
}

export default Footer
